import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import TariffCatalogForm from 'Services/ProductManagement/Features/Tariff/Components/TariffCatalogForm'
import { useSelectedTariff } from 'Services/ProductManagement/Features/Tariff/Hooks'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { IS_HSL_SERVICE_ENVIRONMENT, PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

function TariffCatalogCreatePage() {
  const { id: tariffId } = useParams()
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs/${tariffId}/sales-channels`
  const { singleTariff } = useSelectedTariff(tariffId)
  const previousLocation = usePreviousLocation(`${baseUrl}`)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariffs`,
      link: `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs`
    },
    {
      title: singleTariff ? singleTariff.description : '',
      link: `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs/${tariffId}/products`
    },
    {
      title: t`Tariff sales channels`,
      link: IS_HSL_SERVICE_ENVIRONMENT ? `${baseUrl}` : ''
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <PageTitle>{t`Create new sales channel`}</PageTitle>
        </Grid>
      </Grid>
      <TariffCatalogForm successBaseUrl={baseUrl} />
    </Box>
  )
}

export default TariffCatalogCreatePage
